// extracted by mini-css-extract-plugin
export var checkbox = "_2s-0";
export var circle = "_2s-3";
export var horizontalContainer = "_2s-7";
export var sm = "_2s-5";
export var switch0 = "_2s-2";
export var switchDisabled = "_2s-8";
export var switchEnabled = "_2s-1";
export var textSwitchContainer = "_2s-9";
export var textSwitchOption = "_2s-a";
export var textSwitchOptionSelected = "_2s-b";
export var verticalContainer = "_2s-6";
export var xs = "_2s-4";